import create from 'zustand';
import type { Category } from '@models/data';

export interface AppDataStore {
  setCurrentCategoryTree: (t?: Category) => void;
  currentCategoryTree?: Category;
}

export const useAppDataStore = create<AppDataStore>(set => ({
  currentCategoryTree: undefined,
  setCurrentCategoryTree: ct => {
    set(() => ({ currentCategoryTree: ct }));
  },
}));
